var map = {
	"./bastard.png": 12,
	"./blue.png": 13,
	"./diver.png": 14,
	"./doctor.png": 15,
	"./firefighter.png": 16,
	"./gun.png": 17,
	"./hat.png": 18,
	"./logo.png": 19,
	"./matapacos.png": 20,
	"./money.png": 21,
	"./personwaving.png": 22,
	"./teargas.png": 23,
	"./volunteer.png": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;